export type Seen = {
  for: string;

  settled: boolean;

  verdict: Map<string, boolean>;
};

export function nothingSeen(conversation: string): Seen {
  return { for: conversation, settled: false, verdict: new Map() };
}

export function seeing(seen: Seen, conversation: string, keys: readonly string[]): Seen {
  const now = seen.for === conversation ? seen : nothingSeen(conversation);
  const verdict = new Map(now.verdict);
  for (const key of keys) if (!verdict.has(key)) verdict.set(key, now.settled);
  return { for: conversation, settled: now.settled, verdict };
}

export function settled(seen: Seen): Seen {
  return seen.settled ? seen : { ...seen, settled: true };
}

export function arriving(seen: Seen, key: string): boolean {
  return seen.verdict.get(key) === true;
}
